import {
  Box,
  IconButton,
  InputAdornment,
  InputBase,
  alpha
} from '@mui/material';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

interface MenuSearchProps {
  value: string;
  onChange: (value: string) => void;
  /** Enter: open the first match. */
  onSubmit: () => void;
}

/** "Menüde ara" field at the top of the sidebar. */
const MenuSearch = ({ value, onChange, onSubmit }: MenuSearchProps) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ px: 1.5, pt: 1.5, pb: 0.5 }}>
      <InputBase
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit();
          } else if (event.key === 'Escape') {
            onChange('');
          }
        }}
        placeholder={t('nav.search.placeholder')}
        inputProps={{ 'aria-label': t('nav.search.placeholder') }}
        fullWidth
        startAdornment={
          <InputAdornment position="start">
            <SearchTwoToneIcon
              fontSize="small"
              sx={{ color: (theme) => theme.colors.alpha.trueWhite[50] }}
            />
          </InputAdornment>
        }
        endAdornment={
          value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label={t('nav.search.clear')}
                onClick={() => onChange('')}
                sx={{ color: (theme) => theme.colors.alpha.trueWhite[50] }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null
        }
        sx={(theme) => ({
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          fontSize: theme.typography.pxToRem(14),
          color: theme.colors.alpha.trueWhite[100],
          backgroundColor: alpha(theme.colors.alpha.trueWhite[100], 0.06),
          '&.Mui-focused': {
            backgroundColor: alpha(theme.colors.alpha.trueWhite[100], 0.1)
          }
        })}
      />
    </Box>
  );
};

export default MenuSearch;
